import React from "react";

import cx from "classnames";

import styles from "./UtilityText.scss";

export interface UtilityTextProps {
  /** Indicates if the text should have a pill style */
  pill?: boolean;
  /** The size of the utility text */
  size?: "regular" | "small" | "extraSmall" | "pill" | "counter" | "label";
  /** Additional CSS class names to apply */
  className?: string;
}

/**
 * UtilityText component for displaying text with different sizes and styles.
 */
export function UtilityText({
  children,
  pill = false,
  size = "regular",
  className = "",
}: React.PropsWithChildren<UtilityTextProps>) {
  const classNames = cx(styles.base, className, {
    [styles["utility-text--pill"]]: pill,
    [styles["text--regular"]]: size === "regular",
    [styles["text--small"]]: size === "small",
    [styles["text--extra-small"]]: size === "extraSmall",
    [styles["text--pill"]]: size === "pill",
    [styles["text--counter"]]: size === "counter",
    [styles["text--label"]]: size === "label",
  });

  if (size === "label") {
    return (
      <label className={classNames} data-testid="utility-text">
        {children}
      </label>
    );
  }

  return (
    <span className={classNames} data-testid="utility-text">
      {children}
    </span>
  );
}
